import { ChildRecipeEntity, LocationsEntity, SchedulesEntity } from '@core/redux/stores';
import { TaxRoundingType } from '@features/ordering/utilties/enums/tax-calculator.utility';

export class ReceiptInfo {
  orderNumber: number | null;
  pickupTime: string | null;
  subTotal: string | null;
  tax: string | null;
  total: string | null;
  isFavorite: boolean | null;
  pickupLocation: Location | null;
  pickupType: string | null;
  recipes: (MealRecipePriceEntity)[] | null;
  taxRoundingType: TaxRoundingType | TaxRoundingType.RoundAwayFromZero;
  orderTotalLineItems?: OrderTotalLineItem[];
}
export interface OrderTotalLineItem {
  description?: string;
  itemType?: OrderLineItemType;
  hexColor?: string;
  amount?: number;
  formattedAmount?: string;
}
export enum OrderLineItemType {
  item = 1,
  subtotal = 2,
  serviceFee = 3,
  deliveryFee = 4,
  tip = 5,
  tax = 6,
  total = 7,
  locationFee = 8
}
export enum ReceiptItemType {
    Meal = 0,
    Entree = 1,
    Side = 2,
    Drink = 3,
    Modifier = 4,
    SpecialInstruction = 5,
    Ice = 6,
    Other = 7,
    Fee = 8
}
export class MealRecipePriceEntity {
  name: string | null;
  price: string | null;
  customizations: (MealCustomizationPriceEntity)[] | null;
  receiptItemType?: ReceiptItemType;
}
export class MealCustomizationPriceEntity {
  name: string | null;
  price: string | null;
}
export class FavOrder {
  customizations: (MealCustomizationPriceEntityforFavourite)[] | null;
}
export class MealCustomizationPriceEntityforFavourite {
  customizationGroupId: number | null;
  modifierGroupId: number | null;
  modifierId: number | null;
  specialInstructionIds: any;
}


